import {
  UPDATE_PAYMENT_SETTINGS,
  UPDATE_PAYMENT_AMOUNT,
  RECEIVE_PAYMENT_AUTHORIZATION,
} from '../../actions/payments';

export const initialState = {
  enabled: false,
  amountDue: null,
  formattedAmountDue: '',
  paymentApiKey: '',
  paymentAuthorization: null,
};

export default (
  state = initialState,
  {
    type,
    data: { paymentAuthorization, enabled, paymentApiKey, amountDue, formattedAmountDue } = {},
  } = {},
) => {
  switch (type) {
    case UPDATE_PAYMENT_SETTINGS:
      return {
        ...state,
        enabled,
        paymentApiKey,
      };

    case UPDATE_PAYMENT_AMOUNT: {
      return {
        ...state,
        amountDue,
        formattedAmountDue,
      };
    }

    case RECEIVE_PAYMENT_AUTHORIZATION:
      return {
        ...state,
        paymentAuthorization,
      };

    default:
      return state;
  }
};
